import utils from './utils.es6';

const authEnvData = utils.getAuthEnv();
const baseUrl = authEnvData.authEnv;

/*
 * isNonProd value comes from getAuthEnv method in utils
 * if value is false then the environment is staging or live
 * if value is true then the environment is lsocalhost, dev, qa and preview
 */
export const { isNonProd } = authEnvData;

/*
 * check available environments in Vue Runtime
 * to the appropriate SOLR env endpoint
 */
export const videoApi = () => {
	const apiURL = `${baseUrl}video_api?id=`;

	return apiURL;
};

export const videoQueueApi = () => {
	const videoQApiURL = `${baseUrl}video_queue?`;

	return videoQApiURL;
};
